(() => {
  const header = document.querySelector('[data-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const onScroll = () => header && header.classList.toggle('scrolled', window.scrollY > 35);
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  if(menuToggle && mobileMenu){
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', mobileMenu.classList.contains('open'));
    });
  }
})();

/* ---- Live cart count + add-to-cart without leaving the page ---- */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let toastTimer;

  function setCount(count, animate) {
    document.querySelectorAll('[data-cart-count-badge]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      if (animate && count > 0) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    document.querySelectorAll('.cart-bag').forEach((el) => el.setAttribute('data-cart-count', count));
    document.querySelectorAll('[data-cart-count-text]').forEach((el) => { el.textContent = count; });
    document.querySelectorAll('[data-cart-link]').forEach((el) => el.setAttribute('aria-label', 'Cart, ' + count + ' items'));
  }

  function showToast(message, isError) {
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.querySelector('[data-cart-toast-msg]').textContent = message;
    toast.classList.toggle('error', !!isError);
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 4000);
  }

  function refreshCount(animate) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => setCount(cart.item_count, animate))
      .catch(() => {});
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const label = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }

    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          showToast(data.description || data.message || 'Sorry, this item could not be added.', true);
          return;
        }
        const qty = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
        showToast(qty > 1 ? qty + ' pieces added to your cart' : 'Added to your cart', false);
        return refreshCount(true);
      })
      .catch(() => form.submit())
      .finally(() => { if (button) { button.disabled = false; button.innerHTML = label; } });
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(false); });
})();